import { Card, CardContent } from "@/components/ui/card"
import { H3, Small } from "@/components/ui/typography"
import { Flex } from "@chakra-ui/react"
import { Briefcase, DollarSign, MapPin } from "lucide-react"
import React from "react"

type VehicleSummaryProps = {
	totalMileage: string
	businessTrips: string
	totalSavings: string
}

export const VehicleSummary: React.FC<VehicleSummaryProps> = (props) => {
	return (
		<div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-6">
			<Card className="flex items-center">
				<CardContent className="p-6 flex-1">
					<Flex className="justify-between">
						<Small>Total Mileage</Small>
						<MapPin className="w-5 h-5 text-muted-foreground ml-6" />
					</Flex>
					<H3 className="font-bold">{props.totalMileage}</H3>
				</CardContent>
			</Card>
			<Card className="flex items-center">
				<CardContent className="p-6 flex-1">
					<Flex className="justify-between">
						<Small className="text-sm">Business Trips</Small>
						<Briefcase className="w-5 h-5 text-muted-foreground ml-6" />
					</Flex>
					<H3 className="font-bold">{props.businessTrips}</H3>
				</CardContent>
			</Card>
			<Card className="flex items-center">
				<CardContent className="p-6 flex-1">
					<Flex className="justify-between">
						<Small>Total Savings</Small>
						<DollarSign className="w-5 h-5 text-muted-foreground ml-6" />
					</Flex>
					<H3 className="font-bold">{props.totalSavings}</H3>
				</CardContent>
			</Card>
		</div>
	)
}
